const MEMBER_INFO_KEY = 'memberInfo'
const LOGIN_TOKEN_KEY = 'memberLoginToken'

// 统一处理登录信息序列化，避免各页面直接 JSON.parse 导致应用崩溃。
const getMember = () => {
    const value = localStorage.getItem(MEMBER_INFO_KEY)
    if (!value) return null

    try {
        return JSON.parse(value)
    } catch (error) {
        localStorage.removeItem(MEMBER_INFO_KEY)
        return null
    }
}

const setMember = (member) => {
    if (!member) {
        localStorage.removeItem(MEMBER_INFO_KEY)
        return
    }
    localStorage.setItem(MEMBER_INFO_KEY, JSON.stringify(member))
}

const clearMember = () => {
    localStorage.removeItem(MEMBER_INFO_KEY)
}

const getToken = () => localStorage.getItem(LOGIN_TOKEN_KEY)

const setToken = (token) => {
    // 登录凭证单独保存，访客登录时清除旧账号留下的凭证。
    if (token) localStorage.setItem(LOGIN_TOKEN_KEY, token)
    else localStorage.removeItem(LOGIN_TOKEN_KEY)
}

const clearToken = () => localStorage.removeItem(LOGIN_TOKEN_KEY)

export const authStorage = {
    getMember,
    setMember,
    clearMember,
    getToken,
    setToken,
    clearToken,
}
